import type { RawGreenFeatureProps } from '../../shared/data/types';
import { formatArea, formatLengthKm } from './formatters';

export function buildTooltipHtml(polygon: RawGreenFeatureProps): string {
  const leader = polygon.TeamLeader || '待补充';
  const team = polygon.TeamInform || '待补充';
  const dateText = polygon.SurveyDate || '待补充';
  const layerName = polygon.Layer || '未命名地块';
  const shapeLengthKm = polygon.Shape_Leng / 1000;
  const roadLengthKm = polygon.RoadLength / 1000;

  return `
    <div class="polygon-tip">
      <div class="polygon-tip-title">${layerName}</div>
      <div class="polygon-tip-list">
        <div class="polygon-tip-row is-metric">
          <span class="polygon-tip-label">面积</span>
          <span class="polygon-tip-value">${formatArea(polygon.Shape_Area)} ㎡</span>
        </div>
        <div class="polygon-tip-row is-metric">
          <span class="polygon-tip-label">作业长度</span>
          <span class="polygon-tip-value">${formatLengthKm(shapeLengthKm)} km</span>
        </div>
        <div class="polygon-tip-row is-metric">
          <span class="polygon-tip-label">道路长度</span>
          <span class="polygon-tip-value">${formatLengthKm(roadLengthKm)} km</span>
        </div>
        <div class="polygon-tip-row">
          <span class="polygon-tip-label">负责人</span>
          <span class="polygon-tip-value">${leader}</span>
        </div>
        <div class="polygon-tip-row">
          <span class="polygon-tip-label">班组</span>
          <span class="polygon-tip-value">${team}</span>
        </div>
        <div class="polygon-tip-row">
          <span class="polygon-tip-label">测绘时间</span>
          <span class="polygon-tip-value">${dateText}</span>
        </div>
      </div>
    </div>
  `;
}
